// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#assistant-stawag-waerme-plus-gjuce .v-list-item-group .v-list-item--active{color:inherit}", ""]);
// Exports
module.exports = exports;
